//* 记录用户访问记录
export default defineNuxtRouteMiddleware(async (to, from) => {
    //* store数据
    const user = useUserStore();

    if (import.meta.client) {
        api.middleware("Access", to, "/api/user/access", {
            headers: { "X-Token": useCookie("X-Token").value || "", "X-Client-Uid": get_canvas_fingerprint() },
            method: "POST",
            data: {
                id: user.id,
                url: location.href,
                page: to.meta.type || "Other",
            },
        });
    }
});
